import { render, staticRenderFns } from "./CorePatientsAppBar.vue?vue&type=template&id=4ef29fb9"
import script from "./CorePatientsAppBar.vue?vue&type=script&lang=js"
export * from "./CorePatientsAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports